import { EduElse, EduIf, EduThen } from '@edulastic/common'
import React from 'react'
import { StyledReactPlayer } from '../../styled-components/VideoPreview'
import { extractVideoId } from '../../utils/videoPreviewHelpers'
import YouTubePlayer from './YouTubePlayer'

const CombinedPlayer = React.forwardRef(
  ({ url, onEmbedTokenStatus, ...props }, ref) => {
    const showTYEducational = !!extractVideoId(url)

    const playerProps = {
      ref,
      url,
      ...props,
    }

    return (
      <EduIf condition={showTYEducational}>
        <EduThen>
          {/* onEmbedTokenStatus is YouTube-v2 specific; keep it off ReactPlayer. */}
          <YouTubePlayer
            {...playerProps}
            onEmbedTokenStatus={onEmbedTokenStatus}
          />
        </EduThen>
        <EduElse>
          <StyledReactPlayer {...playerProps} />
        </EduElse>
      </EduIf>
    )
  }
)

export default CombinedPlayer
